const STORAGE_KEY = "created-appointments";
const getStoredAppointment = (id) => {
  const isClient = typeof window !== "undefined";
  if (!id || !isClient) {
    return null;
  }
  const json = window.sessionStorage.getItem(STORAGE_KEY) ?? "{}";
  const appointments = JSON.parse(json);
  const appointment = appointments[id] ?? null;
  return appointment ? {
    ...appointment,
    startTime: new Date(appointment.startTime),
    endTime: new Date(appointment.endTime)
  } : null;
};
const setStoredAppointment = (appointment) => {
  const isClient = typeof window !== "undefined";
  if (!isClient) {
    return false;
  }
  const json = window.sessionStorage.getItem(STORAGE_KEY) ?? "{}";
  const appointments = JSON.parse(json);
  appointments[appointment.id] = appointment;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(appointments));
  return true;
};
export {
  getStoredAppointment,
  setStoredAppointment
};
//# sourceMappingURL=book-appointment-storage.js.map
